import { Link } from 'react-router-dom';
import { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.01] cursor-pointer flex flex-col"
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
        <img
          src={article.image}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={article.title}
        />
        <span className="absolute top-3 left-3 bg-accent-500 text-background-50 text-xs px-2.5 py-1 rounded-full font-medium">
          {article.category}
        </span>
      </div>
      <div className="p-5 flex-1 flex flex-col">
        <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
          <span>{article.date}</span>
          <span>·</span>
          <span>{article.readTime}阅读</span>
          <span>·</span>
          <span>{article.author}</span>
        </div>
        <h2 className="text-base font-semibold text-foreground-900 line-clamp-2 leading-snug mb-2 group-hover:text-primary-500 transition-colors duration-200">
          {article.title}
        </h2>
        <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed flex-1">
          {article.excerpt}
        </p>
        <div className="flex items-center gap-1 mt-3 text-primary-500 text-sm font-medium">
          阅读全文
          <i className="ri-arrow-right-line text-xs"></i>
        </div>
      </div>
    </Link>
  );
}